import React from 'react';
import { STATUSES, STATUS_LABELS, STATUS_MEANINGS } from '../constants/consultationStatus';
import './ConfirmationModal.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

/** Read-only reference of what each consultation status means. */
const StatusMeaningsModal: React.FC<Props> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Consultation statuses</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <dl style={{ margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {STATUSES.map((s) => (
              <div key={s}>
                <dt style={{ fontWeight: 600, marginBottom: '2px' }}>{STATUS_LABELS[s]}</dt>
                <dd style={{ margin: 0, color: '#4b5563', fontSize: '14px' }}>{STATUS_MEANINGS[s]}</dd>
              </div>
            ))}
          </dl>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Got it</button>
        </div>
      </div>
    </div>
  );
};

export default StatusMeaningsModal;
